import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import { getServicesDetailList } from "../../store/Slice/servicesDetailSlice";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [activeMenu, setActiveMenu] = React.useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();
  const location = useLocation();
  const [activelink, setActiveLink] = React.useState("");

  const customerLoggedIn = sessionStorage.getItem("Customer-vUniqueCode");
  const contractorLoggedIn = sessionStorage.getItem("Contractor-vUniqueCode");

  React.useEffect(() => {
    if (
      location.pathname.includes("/move-out-move-in-clean") ||
      location.pathname.includes("/deep-cleaning") ||
      location.pathname.includes("/post-event-cleanup") ||
      location.pathname.includes("/routine-clean")
    ) {
      setActiveMenu("Services");
    } else {
      setActiveMenu(null);
    }
  }, [location.pathname]);

  const handleLoginClick = () => {
    navigate("/login");
  };
  const handleRegisterClick = () => {
    navigate("/register");
  };

  const handleJoinUsClick = () => {
    navigate("/join-us");
  };

  const handleAboutUsClick = (linkName) => {
    setActiveLink(linkName);
  };

  const handleContactClick = (linkName) => {
    setActiveLink(linkName);
  };

  const handleBookNowClick = () => {
    navigate("/book-now");
  };

  const handleAccountClick = () => {
    navigate("/profile");
  };

  const { servicesDetailData } = useSelector(
    (state) => state.servicesDetailList
  );

  React.useEffect(() => {
    if (!servicesDetailData) {
      dispatch(getServicesDetailList());
    }
  }, [dispatch, servicesDetailData]);

  const generateSlug = React.useCallback((serviceName) => {
    return (
      "/" +
      serviceName
        .toLowerCase()
        .replace(/\//g, "-") // replace / with -
        .replace(/\s+/g, "-") // replace spaces with -
        .replace(/[^a-z0-9-]/g, "") // remove special characters except -
    );
  }, []); // Empty dependency array means the callback will not change unless explicitly modified

  const serviceList = React.useMemo(() => {
    return servicesDetailData &&
      servicesDetailData.code === 200 &&
      servicesDetailData.data
      ? servicesDetailData.data.map((service, serviceIndex) => (
          <li key={serviceIndex}>
            <Link
              className="dropdown-item"
              to={generateSlug(service.vServiceName)}
              state={{ serviceId: service.iServiceId }}
            >
              {service.vServiceName}
            </Link>
          </li>
        ))
      : null;
  }, [servicesDetailData, generateSlug]);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img
              className="header-logo"
              // width="216"
              // height="50"
              width="172.8"
              height="36.43"
              // src="/assets/images/logo.png"
              src="/assets/images//logo.webp"
              alt="Logo"
              // loading="lazy"
            />
          </Link>
          <button className="navbar-toggler" type="button" onClick={handleShow}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
          
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li
                  className={`nav-item ${
                    activelink === "About Us" ? "active" : ""
                  }`}
                >
                  <Link
                    className={`nav-link ${
                      location.pathname === "/about-us" ? "active" : ""
                    }`}
                    to="/about-us"
                    onClick={() => handleAboutUsClick("About Us")}
                  >
                    About
                  </Link>
                </li>

                <li
                  className={`nav-item dropdown service-dropdown ${
                    activeMenu === "Services" ? "active" : ""
                  }`}
                >
                  <Link
                    className={`nav-link dropdown-toggle ${
                      activeMenu === "Services" ? "active" : ""
                    }`}
                    to="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Services
                  </Link>
                  <ul className="dropdown-menu">
                    {/* {servicesDetailData &&
                  servicesDetailData.code === 200 &&
                  servicesDetailData.data ? (
                    servicesDetailData.data.map((service, serviceIndex) => (
                      <li key={serviceIndex}>
                        <Link
                          className="dropdown-item"
                          to={generateSlug(service.vServiceName)}
                          state={{ serviceId: service.iServiceId }}
                        >
                          {service.vServiceName}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <></>
                  )} */}
                    {serviceList}
                  </ul>
                </li>
              </ul>
            
            <div className="d-flex gap-3">
           
                <button
                  className="success-orangebtn"
                  type="submit"
                  onClick={handleBookNowClick}
                >
                  Book Now
                </button>
{/*               
              {
                !customerLoggedIn &&
                !contractorLoggedIn && (
                  <button className="white-headerbtn" type="submit">
                    <span onClick={handleLoginClick}>Log In /</span>{" "}
                    <span onClick={handleRegisterClick}>Register</span>
                  </button>
                )
              } */}
              {contractorLoggedIn || customerLoggedIn ? (
                <button
                 
                  className="white-headerbtn"
                  type="submit"
                  onClick={handleAccountClick}
                >
                  Account
                </button>
              ) : (
                <button
                 
                  className="white-headerbtn"
                  type="submit"
                  onClick={handleJoinUsClick}
                >
                  Join Us
                </button>
              )}
            </div>
          </div>
        </div>
      </nav>
      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Link className="navbar-brand" to="/">
            <img
              className="header-logo"
              width="216"
              height="50"
              src="/assets/images/logo.png"
              alt="Logo"
              loading="lazy"
            />
          </Link>
          {/* <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button> */}
        </Offcanvas.Header>
        <div className="offcanvas-body">
       
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li
                className={`nav-item ${
                  activelink === "About Us" ? "active" : ""
                }`}
              >
                <Link
                  className={`nav-link ${
                    location.pathname === "/about-us" ? "active" : ""
                  }`}
                  to="/about-us"
                  onClick={() => handleAboutUsClick("About Us")}
                >
                  About
                </Link>
              </li>
              <li
                className={`nav-item dropdown services-responsive-dropdown ${
                  activeMenu === "Services" ? "active" : ""
                }`}
              >
                <Link
                  className={`nav-link dropdown-toggle ${
                    activeMenu === "Services" ? "active" : ""
                  }`}
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Services
                </Link>
                <ul className="dropdown-menu">
                  {/* {servicesDetailData &&
                servicesDetailData.code === 200 &&
                servicesDetailData.data ? (
                  servicesDetailData.data.map((service, serviceIndex) => (
                    <li key={serviceIndex}>
                      <Link
                        className="dropdown-item"
                        to={generateSlug(service.vServiceName)}
                        state={{ serviceId: service.iServiceId }}
                      >
                        {service.vServiceName}
                      </Link>
                    </li>
                  ))
                ) : (
                  <></>
                )} */}
                  {serviceList}
                </ul>
              </li>
            </ul>
          

          <div className="d-flex gap-3 flex-wrap flex-column align-items-start">
        
              <button
                className="success-orangebtn"
                type="submit"
                onClick={handleBookNowClick}
              >
                Book Now
              </button>
         
            {/* {
              !customerLoggedIn &&
              !contractorLoggedIn && (
                <button className="white-headerbtn" type="submit">
                  <span onClick={handleLoginClick}>Log In /</span>{" "}
                  <span onClick={handleRegisterClick}>Register</span>
                </button>
              )
            } */}
            {contractorLoggedIn || customerLoggedIn ? (
              <button
                className="white-headerbtn"
                type="submit"
                onClick={handleAccountClick}
              >
                Account
              </button>
            ) : (
              <button
                className="white-headerbtn"
                type="submit"
                onClick={handleJoinUsClick}
              >
                Join Us
              </button>
            )}
          </div>
        </div>
      </Offcanvas>{" "}
    </>
  );
};

export default Header;
